import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/student/src/app/login/login.tsx");
